import { colorSystem, INTER } from '@luminovo/design-system';

export const chartTheme = {
    fontFamily: INTER,
    axisTick: { fontSize: 12, fill: colorSystem.neutral[7], fontFamily: INTER },
    axisLine: { stroke: colorSystem.neutral[3] },
    grid: { stroke: colorSystem.neutral[3], strokeDasharray: '4 1 2' },
    tooltip: {
        border: `1px solid ${colorSystem.neutral[2]}`,
        borderRadius: 6,
        boxShadow: '0px 4px 8px rgba(158, 158, 158, 0.15)',
    },
    barHeight: 28,
    maxLabelChars: 36,
} as const;
